export interface FilterOption {
  label: string;
  val: string;
}

export const STATUS_FILTER_OPTIONS: FilterOption[] = [
  { label: "All Statuses", val: "" },
  { label: "Active", val: "true" },
  { label: "Deactive", val: "false" },
  { label: "Demo", val: "demo" },
  { label: "Onhold", val: "onhold" },
];

export const MULTI_BRAND_FILTER_OPTIONS: FilterOption[] = [
  { label: "All", val: "" },
  { label: "Yes", val: "true" },
  { label: "No", val: "false" },
];

export const APPROVAL_FILTER_OPTIONS: FilterOption[] = [
  { label: "All", val: "" },
  { label: "Approved", val: "true" },
  { label: "Pending", val: "false" },
];

export const INTEGRATION_PARTY_FILTER_OPTIONS: FilterOption[] = [
  { label: "All Parties", val: "" },
  { label: "GT", val: "GT" },
  { label: "UP", val: "UP" },
];

export const INVOICE_STATUS_FILTER_OPTIONS: FilterOption[] = [
  { label: "All Statuses", val: "" },
  { label: "Unpaid", val: "Unpaid" },
  { label: "Paid", val: "Paid" },
  { label: "Overdue", val: "overdue" },
  { label: "Void", val: "Void" },
];

export const INVOICE_TIME_RANGE_OPTIONS: FilterOption[] = [
  { val: "", label: "All Time" },
  { val: "today", label: "Today" },
  { val: "yesterday", label: "Yesterday" },
  { val: "7d", label: "Last 7 Days" },
  { val: "30d", label: "Last 30 Days" },
  { val: "this_month", label: "This Month" },
  { val: "last_month", label: "Last Month" },
  { val: "this_year", label: "This Year" },
  { val: "custom", label: "Custom" },
];

export const INVOICE_DATE_FIELD_OPTIONS = [
  { value: "dateOfIssue", label: "Date of Issue" },
  { value: "dueDate", label: "Due Date" },
  { value: "createdAt", label: "Created Date" },
  { value: "updatedAt", label: "Updated Date" },
];

export const BILLING_CYCLE_FILTER_OPTIONS: FilterOption[] = [
  { label: "All Cycles", val: "" },
  { label: "1 Month", val: "1 Month" },
  { label: "3 Months", val: "3 Months" },
  { label: "6 Months", val: "6 Months" },
  { label: "1 Year", val: "1 Year" },
];

export interface TableColumnOption {
  key: string;
  label: string;
}

export const ALL_BRAND_COLUMNS: TableColumnOption[] = [
  { key: "name", label: "Brand Name" },
  { key: "locationData", label: "Location" },
  { key: "region", label: "Region" },
  { key: "isMultiBrand", label: "Multi-Brand" },
  { key: "invoicependingCount", label: "Pending Invoices" },
  { key: "latestInvoice", label: "Latest Invoice" },
  { key: "totalDueAmount", label: "Total Due Amount" },
  { key: "view", label: "Summary" },
  { key: "isActive", label: "Active" },
  { key: "isApproved", label: "Approval" },
  { key: "_id", label: "Action" },
];

export const ALL_CUSTOMER_COLUMNS: TableColumnOption[] = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phoneNumber", label: "Phone" },
  { key: "country", label: "Country" },
  { key: "isActive", label: "Active" },
  { key: "view", label: "View Details" },
  { key: "_id", label: "Delete" },
];

export const ALL_INVOICE_COLUMNS: TableColumnOption[] = [
  { key: "invoiceNumber", label: "Invoice Number" },
  { key: "billTo.name", label: "Customer Name" },
  { key: "brandName", label: "Brand Name" },
  { key: "issueDate", label: "Issue Date" },
  { key: "dueDate", label: "Due Date" },
  { key: "status", label: "Status" },
  { key: "view", label: "View Details" },
  { key: "_id", label: "Delete" },
];

export const ALL_SUBSCRIPTION_COLUMNS: TableColumnOption[] = [
  { key: "planName", label: "Subscription Name" },
  { key: "billingCycle", label: "Billing Cycle" },
  { key: "amount", label: "Amount" },
  { key: "view", label: "Details" },
  { key: "_id", label: "Delete" },
];

export const BILLING_CYCLE_OPTIONS = [
  { value: "", label: "Select Billing Cycle" },
  { value: "1 Month", label: "1 Month" },
  { value: "3 Months", label: "3 Months" },
  { value: "6 Months", label: "6 Months" },
  { value: "12 Months", label: "12 Months" },
];

export const ALL_GROUP_COLUMNS: TableColumnOption[] = [
  { key: "name", label: "Group Name" },
  { key: "description", label: "Description" },
  { key: "isActive", label: "Active" },
  { key: "_id", label: "Action" },
];

export const ADMIN_USER_REGION_OPTIONS = [
  { value: "", label: "Region(All)" },
  { value: "IN", label: "IN" },
  { value: "AE", label: "AE" },
  { value: "QA", label: "QA" },
  { value: "KW", label: "KW" },
];

export const ALL_ADMIN_USER_COLUMNS: TableColumnOption[] = [
  { key: "userName", label: "User Name" },
  { key: "roleName", label: "Role" },
  { key: "selectCountry", label: "Country" },
  { key: "createdAt", label: "Created At" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_ADMIN_USER_MANAGE_COLUMNS: TableColumnOption[] = [
  { key: "userName", label: "User Name" },
  { key: "selectAccessRole", label: "Modules" },
  { key: "createdAt", label: "Created At" },
  { key: "selectCountry", label: "Country" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_ACCESS_ROLE_COLUMNS: TableColumnOption[] = [
  { key: "roleName", label: "Role Name" },
  { key: "permissions", label: "Permissions" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_ACCESS_ROLE_MANAGE_COLUMNS: TableColumnOption[] = [
  { key: "roleName", label: "Role Name" },
  { key: "selectModule", label: "Selected Modules" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_ROLE_MODULE_COLUMNS: TableColumnOption[] = [
  { key: "module", label: "Module" },
  { key: "actions", label: "Actions" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_ROLE_MODULE_MANAGE_COLUMNS: TableColumnOption[] = [
  { key: "moduleName", label: "Name" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_COUPON_COLUMNS: TableColumnOption[] = [
  { key: "couponCode", label: "Coupon Code" },
  { key: "discountType", label: "Discount Type" },
  { key: "discountValue", label: "Discount Value" },
  { key: "isActive", label: "Active" },
  { key: "_id", label: "Action" },
];

export const ALL_PACKAGE_COLUMNS: TableColumnOption[] = [
  { key: "packageName", label: "Package Name" },
  { key: "price", label: "Price" },
  { key: "isActive", label: "Active" },
  { key: "_id", label: "Action" },
];

export const ALL_ASSIGN_PLATFORM_COLUMNS: TableColumnOption[] = [
  { key: "customerName", label: "Contact Person Name" },
  { key: "brandName", label: "Brand Name" },
  { key: "storeName", label: "Store Name" },
  { key: "platformName", label: "Platform Name" },
  { key: "_id", label: "Delete" },
];

export const ALL_PLATFORM_COLUMNS: TableColumnOption[] = [
  { key: "photoURL", label: "Platform Image" },
  { key: "platformName", label: "Platform Name" },
  { key: "height", label: "Height" },
  { key: "width", label: "Width" },
  { key: "tags", label: "Tags" },
  { key: "Active", label: "Active" },
  { key: "_id", label: "Delete" },
];

export const ALL_DOCUMENT_COLUMNS: TableColumnOption[] = [
  { key: "customerName", label: "Customer Name" },
  { key: "brandName", label: "Brand Name" },
  { key: "storeName", label: "Store Name" },
  { key: "documentName", label: "Document Name" },
  { key: "document", label: "Document" },
  { key: "documentVersion", label: "Document Version" },
  { key: "status", label: "Status" },
  { key: "_id", label: "Delete" },
];

export const ALL_PAYMENT_COLUMNS: TableColumnOption[] = [
  { key: "paymentReceiptUrl", label: "Download" },
  { key: "invoiceNumber", label: "Invoice Number" },
  { key: "amountPaid", label: "Amount" },
  { key: "status", label: "Status" },
  { key: "paymentDate", label: "Payment Date" },
  { key: "_id", label: "Delete" },
];

export const ALL_STATEMENT_COLUMNS: TableColumnOption[] = [
  { key: "transactionDate", label: "Date" },
  { key: "transactionId", label: "Transaction ID" },
  { key: "name", label: "Customer Name" },
  { key: "amount", label: "Amount" },
  { key: "status", label: "Status" },
  { key: "paymentMethod", label: "Payment Method" },
];

export const ALL_ACTIVITY_LOG_COLUMNS: TableColumnOption[] = [
  { key: "timestamp", label: "Timestamp" },
  { key: "method", label: "Method" },
  { key: "path", label: "Endpoint Path" },
  { key: "status", label: "Status" },
  { key: "level", label: "Level" },
  { key: "responseTime", label: "Resp. Time" },
  { key: "username", label: "User" },
  { key: "userId", label: "User ID" },
  { key: "brandId", label: "Brand ID" },
  { key: "action", label: "Action" },
  { key: "ip", label: "IP" },
  { key: "responseMessage", label: "Response" },
  { key: "view", label: "Details" },
];

export const ADMIN_LOG_COLUMNS: TableColumnOption[] = [
  { key: "timestamp", label: "Timestamp" },
  { key: "method", label: "Method" },
  { key: "path", label: "Endpoint Path" },
  { key: "status", label: "Status" },
  { key: "level", label: "Level" },
  { key: "username", label: "User" },
  { key: "action", label: "Action" },
  { key: "responseTime", label: "Resp. Time" },
  { key: "view", label: "Details" },
];

export const BACKEND_LOG_COLUMNS: TableColumnOption[] = [
  { key: "timestamp", label: "Timestamp" },
  { key: "method", label: "Method" },
  { key: "path", label: "Endpoint Path" },
  { key: "status", label: "Status" },
  { key: "level", label: "Level" },
  { key: "brandId", label: "Brand ID" },
  { key: "responseTime", label: "Resp. Time" },
  { key: "responseMessage", label: "Response" },
  { key: "view", label: "Details" },
];

export const DEFAULT_ADMIN_COLUMNS: string[] = ADMIN_LOG_COLUMNS.map((col) => col.key);
export const DEFAULT_BACKEND_COLUMNS: string[] = BACKEND_LOG_COLUMNS.map((col) => col.key);

export const LOG_HTTP_METHOD_OPTIONS = [
  { value: "", label: "All Methods" },
  { value: "GET", label: "GET" },
  { value: "POST", label: "POST" },
  { value: "PUT", label: "PUT" },
  { value: "PATCH", label: "PATCH" },
  { value: "DELETE", label: "DELETE" },
];

export const LOG_LEVEL_OPTIONS = [
  { value: "", label: "All Levels" },
  { value: "activity", label: "Activity" },
  { value: "error", label: "Error" },
  { value: "warn", label: "Warn" },
  { value: "info", label: "Info" },
  { value: "debug", label: "Debug" },
];

export const LOG_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "200", label: "200 OK" },
  { value: "201", label: "201 Created" },
  { value: "400", label: "400 Bad Request" },
  { value: "401", label: "401 Unauthorized" },
  { value: "403", label: "403 Forbidden" },
  { value: "404", label: "404 Not Found" },
  { value: "500", label: "500 Internal Error" },
  { value: "502", label: "502 Bad Gateway" },
  { value: "503", label: "503 Service Unavailable" },
];

/* Activity Log Filter State Types and Defaults */
export interface AdminLogFilterState {
  adminUserId: string;
  username: string;
  action: string;
  level: string;
  status: string;
  method: string;
  startDate: string;
  endDate: string;
}

export interface BackendLogFilterState {
  brandId: string;
  level: string;
  status: string;
  method: string;
  startDate: string;
  endDate: string;
}

export const initialAdminFilterState: AdminLogFilterState = {
  adminUserId: "",
  username: "",
  action: "",
  level: "",
  status: "",
  method: "",
  startDate: "",
  endDate: "",
};

export const initialBackendFilterState: BackendLogFilterState = {
  brandId: "",
  level: "",
  status: "",
  method: "",
  startDate: "",
  endDate: "",
};

export const ADMIN_FILTER_KEYS: (keyof AdminLogFilterState)[] = [
  "adminUserId",
  "username",
  "action",
  "level",
  "status",
  "method",
  "startDate",
  "endDate",
];

export const BACKEND_REQUEST_FILTER_KEYS: (keyof BackendLogFilterState)[] = [
  "brandId",
  "level",
  "status",
  "method",
  "startDate",
  "endDate",
];

export const BACKEND_COMMON_FILTER_KEYS: (keyof BackendLogFilterState)[] = [
  "method",
  "startDate",
  "endDate",
];

export const countActiveFilters = <T extends object>(
  filters: T,
  keys: (keyof T)[]
): number => {
  return keys.reduce((acc, key) => {
    const val = filters[key];
    return typeof val === "string" && val.trim() ? acc + 1 : acc;
  }, 0);
};

export const getActiveAdminFilterCount = (filters: AdminLogFilterState): number => {
  return countActiveFilters(filters, ADMIN_FILTER_KEYS);
};

export const getActiveBackendFilterCount = (
  filters: BackendLogFilterState,
  isBackendRequests: boolean = true
): number => {
  return countActiveFilters(
    filters,
    isBackendRequests ? BACKEND_REQUEST_FILTER_KEYS : BACKEND_COMMON_FILTER_KEYS
  );
};

export const formatDisplayDateTime = (dateTime?: string): string => {
  if (!dateTime) return "";
  return dateTime.replace("T", " ");
};



export const BRAND_COL_OPTIONS: TableColumnOption[] = [
  { key: "outlets", label: "Outlets & Fleet" },
  { key: "volume", label: "Volume Share" },
  { key: "orders", label: "Total Orders" },
  { key: "revenue", label: "Revenue" },
  { key: "payments", label: "Payment Methods" },
  { key: "fulfillment", label: "Order Types" },
  { key: "aggregators", label: "Aggregators" },
  { key: "growth", label: "Growth" },
  { key: "status", label: "Status" },
];

export const STORE_COL_OPTIONS: TableColumnOption[] = [
  { key: "parentBrand", label: "Parent Brand" },
  { key: "volume", label: "Volume Share" },
  { key: "orders", label: "Total Orders" },
  { key: "revenue", label: "Revenue" },
  { key: "avgTicket", label: "Avg. Ticket" },
  { key: "status", label: "Status" },
];

export const BRAND_STORE_COL_OPTIONS: TableColumnOption[] = [
  { key: "subBrand", label: "Sub-Brand" },
  { key: "volume", label: "Volume Share" },
  { key: "orders", label: "Total Orders" },
  { key: "revenue", label: "Revenue" },
  { key: "avgTicket", label: "Avg. Ticket" },
  { key: "status", label: "Status" },
];

export const ORDER_STATUS_OPTIONS: TableColumnOption[] = [
  { key: "Pending", label: "Pending" },
  { key: "Preparing", label: "Preparing" },
  { key: "Ready", label: "Ready" },
  { key: "Dispatched", label: "Dispatched" },
  { key: "Completed", label: "Completed" },
  { key: "Cancelled", label: "Cancelled" },
];

export const DATE_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "7d", label: "7 Days" },
  { value: "30d", label: "30 Days" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "this_year", label: "This Year" },
  { value: "all_time", label: "All Time" },
  { value: "custom", label: "Custom Date Range" },
];

export interface DashboardWidget {
  id: string;
  name: string;
  category: string;
  value: string;
  sub: string;
  viz: string;
  hex: string;
  pts?: number[];
}

export const DASHBOARD_WIDGETS: DashboardWidget[] = [
  { id: "executiveSummary", name: "Executive Summary", category: "Overview", value: "4 Metrics", sub: "revenue, orders, stores...", viz: "grid", hex: "#00BA6A" },
  { id: "ordersOverview", name: "Orders Overview", category: "Overview", value: "4,182", sub: "orders today", viz: "line", hex: "#2E5AAC", pts: [8, 14, 10, 18, 15, 22, 19] },
  { id: "brandPerformance", name: "Brand Performance", category: "Overview", value: "10 Brands", sub: "top performing", viz: "table", hex: "#00BA6A" },
  { id: "topStores", name: "Top Stores", category: "Overview", value: "243 Active", sub: "by revenue", viz: "table", hex: "#2E5AAC" },
  { id: "aggregatorPerformance", name: "Aggregator Performance", category: "Performance", value: "Active", sub: "platforms", viz: "table", hex: "#F59E0B" },
  { id: "customerAnalytics", name: "Customer Analytics", category: "Performance", value: "9,842", sub: "new customers", viz: "donut", hex: "#2E5AAC" },
  { id: "userManagement", name: "User Management", category: "Performance", value: "48", sub: "staff users", viz: "table", hex: "#B7791F" },
  { id: "liveActivityFeed", name: "Live Activity Feed", category: "Performance", value: "Live", sub: "recent actions", viz: "list", hex: "#00BA6A" },
  { id: "recentTransactions", name: "Recent Transactions", category: "Performance", value: "Latest", sub: "transactions", viz: "table", hex: "#2E5AAC" },
  { id: "regionalPerformance", name: "Regional Performance", category: "Performance", value: "5 Regions", sub: "active regions", viz: "grid", hex: "#00BA6A" },
  { id: "subscriptionAnalytics", name: "Subscription Analytics", category: "Performance", value: "₹18.6L", sub: "MRR this month", viz: "grid", hex: "#00BA6A" },
  { id: "platformHealth", name: "Platform Health", category: "Performance", value: "96.1%", sub: "fleet & API uptime", viz: "grid", hex: "#00BA6A" },
  { id: "deviceMonitoring", name: "Device Monitoring", category: "Operations", value: "612 Online", sub: "device status", viz: "list", hex: "#2E5AAC" },
  { id: "alertsAndNotifications", name: "Alerts & Notifications", category: "Insights", value: "12 Unread", sub: "system alerts", viz: "list", hex: "#EF4444" },
  { id: "businessInsights", name: "Business Insights", category: "Insights", value: "3 Insights", sub: "AI generated", viz: "list", hex: "#8B5CF6" },
];

export const BASE_KPIS = [
  { key: "stores", label: "Total Stores", total: 0, active: 0, inactive: 0, trend: "0%", up: true, icon: "building", color: "blue" },
  { key: "invoices", label: "Invoices", total: 0, paid: 0, overdue: 0, totalAmount: 0, trend: "0%", up: true, icon: "receipt", color: "purple" },
  { key: "devices", label: "Devices Fleet", total: 0, active: 0, inactive: 0, trend: "0% Uptime", up: true, icon: "tool", color: "amber" },
  { key: "customers", label: "Customer Base", total: 0, active: 0, inactive: 0, trend: "0 today", up: true, icon: "users", color: "green" },
];

export const ORDER_STATUSES = [
  { label: "Pending", n: 0, c: "var(--amber-500)" },
  { label: "Preparing", n: 0, c: "var(--blue-600)" },
  { label: "Ready", n: 0, c: "var(--green-500)" },
  { label: "Completed", n: 0, c: "var(--green-700)" },
  { label: "Cancelled", n: 0, c: "var(--red-600)" },
];

export const DEFAULT_HEALTH_ITEMS = [
  { name: "API Status", val: "Operational", pct: 100, color: "var(--green-500)" },
  { name: "Database", val: "Healthy", pct: 100, color: "var(--green-500)" },
  { name: "Server Load", val: "0%", pct: 0, color: "var(--green-500)" },
];

export const BRAND_DASHBOARD_ORDER_STATUSES = [
  { id: 'Pending', label: 'Pending', count: 0, revenue: 0, color: '#F59E0B' },
  { id: 'Preparing', label: 'Preparing', count: 0, revenue: 0, color: '#2563EB' },
  { id: 'Ready', label: 'Ready', count: 0, revenue: 0, color: '#10B981' },
  { id: 'Dispatched', label: 'Dispatched', count: 0, revenue: 0, color: '#3B82F6' },
  { id: 'Completed', label: 'Completed', count: 0, revenue: 0, color: '#10B981' },
  { id: 'Cancelled', label: 'Cancelled', count: 0, revenue: 0, color: '#EF4444' }
];

export const CURRENCY_OPTIONS = [
  { value: 'INR', label: '₹ INR' },
  { value: 'AED', label: 'د.إ AED' },
  { value: 'SAR', label: 'ر.س SAR' },
  { value: 'USD', label: '$ USD' },
];

export const GLOBAL_CURRENCY_OPTIONS = [
  { value: "", label: "Auto Currency" },
  { value: 'INR', label: '₹ INR' },
  { value: 'AED', label: 'د.إ AED' },
  { value: 'USD', label: '$ USD' },
];

